export default ({ request }) => ({
  ecomAmzFtyInboundListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/inbound/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyInboundDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/inbound/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyInboundGenerateApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/inbound/generate',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyInboundSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/inbound/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyInboundDelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/inbound/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyInboundAuditApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/inbound/audit',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyInboundDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/inbound/detail/list',
      method: 'POST',
      data,
    })
  },
})
